import { styled, Grid } from '@mui/material';
import React from 'react';
import { TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import PageCard from '../components/PageCard/index.js';

var Container = styled('div')(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            boxSizing: 'border-box',
            fontFamily: 'Poppins',
            color: theme.palette.primary.main,
            padding: "30px 0",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            textAlign: 'left',
            flexDirection: 'column'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            padding: "30px ".concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            padding: "30px ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b['.container-grid'] = (_c = {
                maxWidth: DESKTOP_SCREEN_SIZE,
                width: '100%'
            },
            _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                backgroundColor: '#fff',
            },
            _c["@media (max-width: 600px)"] = {
                justifyContent: 'center',
            },
            _c),
        _b['.no-data-container'] = {
            minHeight: '50vh',
            h1: {
                fontColor: theme.palette.primary.main,
                fontFamily: 'Poppins',
            },
        },
        _b);
});
var TitleContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '30px',
        lineHeight: '42px',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        marginBottom: '30px',
    });
});
var EditorialMoreFromCards = function (_a) {
    var _b, _c, _d;
    var LinkComponent = _a.LinkComponent, persistentQueryParams = _a.persistentQueryParams, site = _a.site, page = _a.page, brandEntity = _a.brandEntity, routePrefix = _a.routePrefix;
    var targetPages = (_c = (_b = site.pages.find(function (p) { return p.pageType === page.pageType; })) === null || _b === void 0 ? void 0 : _b.childPages) !== null && _c !== void 0 ? _c : [];
    var placeholderImage = 'https://media.brandclub.com/cms/widgets/Placeholder_Green_Image_10x7.png';
    if (targetPages.length < 2) {
        // if there is 1 page, it is the page we are on,
        // so we do not want to show this More from... since there are no more to show!
        return null;
    }
    return (React.createElement(Container, null,
        React.createElement(TitleContainer, null,
            "More from ", (_d = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _d === void 0 ? void 0 :
            _d.name),
        React.createElement(Grid, { container: true, flexDirection: "row", justifyContent: "flex-start", spacing: { xs: 1, sm: 1, md: 1.5 }, className: "container-grid" }, targetPages && targetPages.length > 0
            ? targetPages
                .filter(function (e) { return e.route !== page.route; }) // We do not want to show the current page
                .slice(0, 3)
                .map(function (targetPage) {
                return (React.createElement(Grid, { key: targetPage.title, item: true, xs: 12, sm: 6, md: 4 },
                    React.createElement(PageCard, { LinkComponent: LinkComponent, persistentQueryParams: persistentQueryParams, brandEntity: brandEntity, pageType: targetPage.pageType, route: targetPage.route, routePrefix: routePrefix, displayName: targetPage.displayName, createdTime: targetPage.createdTime, previewImageUrl: targetPage.previewImageUrl || placeholderImage, containerStyle: { padding: '30px 18px' }, titleStyle: {
                            fontFamily: 'Poppins',
                            fontSize: 18,
                            lineHeight: 1.56,
                            height: '53px',
                            marginTop: 13,
                            marginBottom: 0,
                        }, dateStyle: {
                            fontSize: 12,
                            marginTop: 20,
                        } })));
            })
            : null)));
};

export { EditorialMoreFromCards, TitleContainer };
//# sourceMappingURL=index.js.map
